module.exports = {"type":"Type","ic":"Registration Number","name":"Name","address":"Address","rowDt":"Insert date","insertDate":"Insert date"}